import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class BlogContent extends React.Component{

    constructor(){
        super();

        
        this.state = {
            blogs : [],
            loading : 1
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }
 


    render()
    { 
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
          <div data-v-a4f83e26="" className="blog-summary">
      <div data-v-a4f83e26="" className="bs-grid">

             
            {this.props.blogs.map((blog, index) => (

                  <Link
          data-v-a4f83e26=""
          to={base_url+'news-info/'+blog.slug}
          className="bs-item aos-init aos-animate"
          data-aos="fade-up"
          data-aos-delay="0"
          style={{
            backgroundImage:
              'url('+blog.image+')',
          }}
        >
          <div data-v-a4f83e26="" className="bs-container">
            <div data-v-a4f83e26="" className="bs-date">
              <div data-v-a4f83e26="" className="bs-month">{blog.created_month}</div>
              <div data-v-a4f83e26="" className="bs-day">{blog.created_date}</div>
            </div>

            <div data-v-a4f83e26="" className="bs-title">
              <div data-v-a4f83e26="" className="bs-headline">
               {blog.title}
              </div>
              <div data-v-a4f83e26="" className="bs-subtitle">
               {blog.short_info}
              </div>
            </div>
          </div>
        </Link>
  
    ))}
   

                
            </div>
        </div>   
    );
}

}

export default BlogContent;